import React from 'react';

import TourGuide from 'src/components/Banners/TourGuide';
import Facts from '../../containers/Facts';
import ExtraItems from '../../containers/ExtraItemsContainer';
import Container from '../Container';
import Paper from '../Paper';
import PaperSeparator from '../Paper/PaperSeparator';
import ReviewBlock from '../ReviewBlock';

interface HotelInfoMobileProps {
  hasFacts: boolean;
  hasExtraItems: boolean;
  isHotelOnly: boolean;
  isExpertReviewExists: boolean;
  isWhiteLabel?: boolean;
}

const HotelInfoMobile = ({
  hasFacts,
  hasExtraItems,
  isHotelOnly,
  isExpertReviewExists,
  isWhiteLabel,
}: HotelInfoMobileProps) => (
  <>
    {/* факты и только на лт */}
    {(hasFacts || hasExtraItems) && (
      <Container isMobile>
        <Paper padding={10}>
          {hasFacts && (
            <>
              <Facts isMobile />
              {hasExtraItems && !isHotelOnly && <PaperSeparator margin={10} />}
            </>
          )}
          <ExtraItems />
        </Paper>
      </Container>
    )}
    {!isHotelOnly && !isWhiteLabel && (
      <Container isMobile>
        <TourGuide isMobile />
      </Container>
    )}
    {isExpertReviewExists && (
      <Container isMobile>
        <ReviewBlock />
      </Container>
    )}
  </>
);

export default React.memo(HotelInfoMobile);
